import { FC, ReactElement, useEffect, useRef, useState } from "react";
import { Progress } from 'antd'
import styles from './index.less'
import { COLOR_PRIMARY } from 'utils/constants'
// import img4 from '@/assets/tmp/4.jpg'
import * as THREE from 'three' 
// import threedBg from '@/assets/threed-bg.jpeg'

import { GLTF, GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js';
import { STLLoader } from 'three/examples/jsm/loaders/STLLoader.js';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader'; 
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import {GUI} from 'three/examples/jsm/libs/lil-gui.module.min.js';
import { KTX2Loader } from 'three/examples/jsm/loaders/KTX2Loader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
import { RoomEnvironment } from 'three/examples/jsm/environments/RoomEnvironment.js';
import { EXRLoader } from 'three/examples/jsm/loaders/EXRLoader.js';

import { WebIO } from '@gltf-transform/core';
import { ALL_EXTENSIONS } from '@gltf-transform/extensions';
import { metalRough } from '@gltf-transform/functions';
// @ts-ignore
// import draco3d from 'draco3dgltf';

import { environments } from 'utils/environments.js';

// import defaultBg from '@/assets/default-bg.png'
const defaultBg = ''

const MANAGER = new THREE.LoadingManager();
const THREE_PATH = `https://unpkg.com/three@0.${THREE.REVISION}.x`
const DRACO_LOADER = new DRACOLoader( MANAGER ).setDecoderPath( `${THREE_PATH}/examples/jsm/libs/draco/gltf/` );
const KTX2_LOADER = new KTX2Loader( MANAGER ).setTranscoderPath( `${THREE_PATH}/examples/jsm/libs/basis/` );

interface TextureProps {
  name: string,
  path: string
}

interface Props {
  name?: string,
  path?: string,
  compressDetailDTO?: any,
  coverImg?: string,
  hdr?: string,
  position?: THREE.Vector3,
  // type: 'glb'|'gltf'|'fbx',
  textures?: TextureProps[],
  autoRotate?: boolean,
  init?: (model?:THREE.Group, geometry?:THREE.Group|GLTF|THREE.BufferGeometry)=>void,
  hidePanel?: boolean,
  className?: string,
  showStatic?: boolean,
  printscreen?:(imgbase64:string)=>void,
  fileSxf?: string
}

// 辅助参数
interface AssistProps {
  showLightOrigin?: boolean,
  wireframe?: boolean,
  background?: string,
  grid?: boolean,
  environment?: string
}

interface Tdm {
  scene?: THREE.Scene,
  camera?: THREE.PerspectiveCamera,
  renderer?: THREE.WebGLRenderer,
  controls?: OrbitControls,
  lights?: {name:string, obj: any, position?:number[], helper?:THREE.PointLightHelper}[],
  mixer?: THREE.AnimationMixer,
  clips?:THREE.AnimationClip[],
  group?: THREE.Group
}

interface ModelProps {
  group?: THREE.Group
}

const TIP_LOADING = '模型加载中...'
const TIP_MODEL = '不支持模型预览'
const TIP_SUCCESS = '加载完成'
const TIP_ERR = '模型加载失败'


const ThreeDView:FC<Props> = (props):ReactElement=>{

  const { compressDetailDTO, showStatic, printscreen, fileSxf } = props
  const canvasRef = useRef<HTMLDivElement>(null)
  const guiRef = useRef<HTMLDivElement>(null)
  const [percent, setPercent] = useState(0)
  const [tdm, setTdm] = useState<Tdm>({})
  const [tip, setTip] = useState(TIP_LOADING)
  const [loadStatus, setLoadStatus] = useState<any>('normal')
  // const [currentModel, setCurrentModel] = useState<ModelProps>()
  const [guiPanel, setGuiPanel] = useState<GUI>()
  const [assistProps, setAssistProps] = useState<AssistProps>({
    wireframe: false,
    showLightOrigin: false,
    background: '#f0f0f0',
    grid: false,
    environment: 'classroom'
  })
  const [animationActions, setAnimationActions] = useState<THREE.AnimationAction[]>() 
  const [barWidth, setBarwidth] = useState<any>()
  const [playing, setPlaying] = useState(false)
  const [playCycle, setPlayCycle] = useState('one')
  const [clipNum, setClipNum] = useState<number>(-1)
  const [playTime, setPlayTime] = useState('00.00')
  const [menuShow, setMenuShow] = useState(false)
  const pointRef = useRef<HTMLDivElement>(null)
  const [fullscreen, setFullscreen] = useState(false)
  const [playAnimCb, setPlayAnimCb] = useState<() => void>()
  const [axesHelper, setAxesHelper] = useState<THREE.AxesHelper>()
  const [gridHelper, setGridHelper] = useState<THREE.GridHelper>()
  const [pmremGenerator, setPmremGenerator] = useState<THREE.PMREMGenerator>()
  const [neutralEnvironment, setNeutralEnvironment] = useState<THREE.Texture>()
  const [showGuiPanel, setShowGuiPanel] = useState(false)

  let currentModel:ModelProps = {}
  
  

  const getCubeMapTexture = ( environment:any ) => {
    const { id, path, format } = environment;

    // neutral (THREE.RoomEnvironment)
    if ( id === 'neutral' ) {

      return Promise.resolve( { envMap: neutralEnvironment } );

    }

    // none
    if ( id === '' ) {

      return Promise.resolve( { envMap: null } );

    }

    if(format === '.hdr'){
      return new Promise( ( resolve, reject ) => {
        const rgbeLoader = new RGBELoader()
        rgbeLoader.load(path, (texture)=> {
            console.log('hdr texture', texture)
            console.log('pmremGenerator', pmremGenerator)
            const envMap = pmremGenerator!.fromEquirectangular(texture).texture;
            // envMap.isPmremTexture = true;
            pmremGenerator!.dispose()
            resolve( { envMap } );
          }, undefined, reject )
      });
    }

    return new Promise( ( resolve, reject ) => {
      
      new EXRLoader()
        .load( path, ( texture ) => {

          const envMap = pmremGenerator!.fromEquirectangular( texture ).texture;
          pmremGenerator!.dispose();

          resolve( { envMap } );

        }, undefined, reject );

    });

  }
  // 修改环境
  const updateEnvironment = ()=> {

    const environment = environments.filter((entry:any) => entry.name === assistProps.environment)[0];

    getCubeMapTexture(environment).then(({envMap}:any) => {

      tdm.scene!.environment = envMap
      tdm.scene!.background = new THREE.Color(assistProps.background)
      //this.scene.background = this.state.background ? envMap : this.backgroundColor;

    });

  }

  const canvasInit = ()=>{
    const canvasDOM = canvasRef.current!
    // 场景
    const md:Tdm = {}
    md.scene = new THREE.Scene()
    // md.scene.background = new THREE.Color(0x282923)
    md.scene.background = new THREE.Color(assistProps.background)
    // new THREE.TextureLoader().load(threedBg, (texture: THREE.Texture)=>{
    //   md.scene!.background = texture
    //   if(md.renderer && md.camera){
    //     md.renderer!.render(md.scene!, md.camera!)
    //   }
    // })


    // 灯光
    md.lights = [
          {name:'AmbientLight',obj:new THREE.AmbientLight(0xFFFFFF, 1)},
          {name:'DirectionalLight_top',obj:new THREE.DirectionalLight(0xFFFFFF, 1),position:[0, 15, 0]},
          // {name:'DirectionalLight_bottom',obj:new THREE.DirectionalLight(0x1B1B1B,3),position:[0, -200, 0]},
          {name:'DirectionalLight_right1',obj:new THREE.DirectionalLight(0xFFFFFF, 1),position:[0, -5, 20]},
          {name:'DirectionalLight_right2',obj:new THREE.DirectionalLight(0xFFFFFF, 1),position:[0, -5, -20]},
    ]
    // md.lights = [
    //   {name:'hemi_light',obj:new THREE.HemisphereLight()},
    //   {name:'ambient_light',obj:new THREE.AmbientLight(0xFFFFFF, 1)},
    //   {name:'main_light',obj:new THREE.DirectionalLight(0xFFFFFF, 1),position:[0.5, 0, 0.866]},
    // ]
    md.lights.forEach((item)=>{
      item.obj.name = item.name
      if(item.position){
        item.obj.position.set(...item.position)
      }
      item.helper = new THREE.PointLightHelper(item.obj);
      md.scene!.add(item.obj)
    })

    //md.scene!.add(md.lights[0].obj);

    // 相机
    md.camera = new THREE.PerspectiveCamera(60, canvasDOM.clientWidth/canvasDOM.clientHeight, 0.01, 1000)
    md.camera.position.set(0, 0, 5)
    md.camera.lookAt(md.scene.position)

    // 渲染
    md.renderer = new THREE.WebGLRenderer({antialias: true,alpha: true,premultipliedAlpha:true,precision: 'highp'}) // , preserveDrawingBuffer: true
    md.renderer.setPixelRatio(window.devicePixelRatio)
    md.renderer.setSize(canvasDOM.clientWidth, canvasDOM.clientHeight);
    md.renderer.setClearColor(0xcccccc);
    md.renderer.shadowMap.enabled = true;
    //@ts-ignore
    // md.renderer.physicallyCorrectLights = true;
    md.renderer.useLegacyLights = false
    md.renderer.outputColorSpace = THREE.SRGBColorSpace;
    // 加入到DOM
    const dom = md.renderer.domElement
    dom.id = 'canvas'
    
    const oldDom = document.getElementById('canvas')
    if(oldDom){
      canvasDOM.removeChild(oldDom)
    }
    canvasDOM.insertBefore(dom, canvasDOM.childNodes[0])

    md.renderer!.render(md.scene!, md.camera!)

    // 添加轨道控制
    md.controls = new OrbitControls(md.camera, md.renderer.domElement);
    // 如果使用animate方法时，将此函数删除
    //controls.addEventListener( 'change', render );
    // 使动画循环使用时阻尼或自转 意思是否有惯性
    md.controls.enableDamping = true;
    //是否可以缩放
    md.controls.enableZoom = true;
    //设置相机距离原点的最远距离-可以控制缩放程度
    md.controls.minDistance = 0;
    //设置相机距离原点的最远距离
    md.controls.maxDistance = 3000;//800
    //是否开启右键拖拽
    md.controls.enablePan = true;
    //动态阻尼系数 就是鼠标拖拽旋转灵敏度
    md.controls.dampingFactor = 0.5;
    //是否自动旋转
    md.controls.autoRotate = props.autoRotate === undefined ? false : props.autoRotate;
    md.controls.autoRotateSpeed = 1;

    
    // 设置 environment neutral
    const pg = new THREE.PMREMGenerator( md.renderer )
    pg.compileEquirectangularShader()
    const ne = pg.fromScene( new RoomEnvironment() ).texture
    setPmremGenerator(pg)
    setNeutralEnvironment(ne)
    //md.scene.environment = neutralEnvironment

    setTdm(md)
    
    window.onresize = ()=>{
      let w = canvasDOM.clientWidth, h = canvasDOM.clientHeight
      const fullscreenElement = document.fullscreenElement 
      // console.log('fullscreenElement', fullscreenElement)
      if(fullscreenElement){
        w = md.renderer!.domElement.clientWidth
        h = md.renderer!.domElement.clientHeight
      }
      md.camera!.aspect = w/h;
      md.camera!.updateProjectionMatrix();
      md.renderer!.setSize(w, h);
      // md.renderer!.setPixelRatio(Math.min(window.devicePixelRatio, 2))
      md.renderer!.render(md.scene!, md.camera!);
      // console.log('window.devicePixelRatio', window.devicePixelRatio, canvasDOM.clientWidth, canvasDOM.clientHeight)
      // console.log('md.renderer!.domElement.clientWidth', md.renderer!.domElement.clientWidth, md.renderer!.domElement.clientHeight)
      
      const trackBar = document.getElementById('trackBar')
      if(trackBar){
        setBarwidth(trackBar!.offsetWidth!)
      }
    }
    
  }

  const animation = (clock:THREE.Clock)=>{
    if(tdm.renderer && tdm.scene && tdm.camera){
      tdm.renderer.render(tdm.scene, tdm.camera)
    }
    // this.TestStats.update();
    if(tdm.controls){
      tdm.controls.update();
    }
    let timer = requestAnimationFrame(()=>animation(clock));
    return timer
  }
  
  // 播放动画
  const playAnim = (n?:number)=>{
    let currentNum = clipNum
    if(n !== undefined){
      currentNum = n
    }
    console.log('播放', currentNum)
    if(playAnimCb){
      playAnimCb()
    }
    if(currentNum === -1){
      setPlaying(false)
    }else{
      setPlaying(true)
    }
    setPlayTime('00.00')
    if(tdm.mixer){
      tdm.mixer.stopAllAction()
    }
    if(pointRef.current){
      pointRef.current.style.transition = 'none'
      pointRef.current.style.transform = 'translateX(0px)'
    }
    if(currentNum === -1 || !tdm.clips || tdm.clips.length===0){
      // TODO 卸载所有动画
      return
    }
    if(tdm.mixer){
      const maxDuration = tdm.clips![currentNum].duration
      const action = animationActions![currentNum]
      //action.reset()
      action.setLoop(THREE.LoopOnce, 0).play()
      if(pointRef.current){
        setTimeout(()=>{
          pointRef.current!.style.transition = `transform ${maxDuration*1000-50}ms linear 0s`
          pointRef.current!.style.transform = `translateX(${document.getElementById('trackBar')?.offsetWidth}px)`
        }, 50)
      }
      const clock = new THREE.Clock()
      let sum = 0, timer = 0
      const run = ()=>{
        if (sum > maxDuration) return
        timer = requestAnimationFrame(run)
        // console.log('timer', timer)
        const t = clock.getDelta()
        if(action.isRunning()){
          sum += t
          setPlayTime(sum.toFixed(2))
        }
        tdm.mixer!.update(t)

        return ()=>{
          return ()=>{
            console.log('cancelAnimationFrame', timer)
            cancelAnimationFrame(timer)
          }
        }
      }
      
      
      return run()
    }
  }

  // 加载高清背景图
  const hdrLoader = (hdr:string)=>{
    const pmremGenerator = new THREE.PMREMGenerator(tdm.renderer!) // 使用hdr作为背景色
    pmremGenerator.compileEquirectangularShader()
    const textureLoader = new RGBELoader()
    textureLoader.load(hdr, (texture)=> {
      const envMap = pmremGenerator.fromEquirectangular(texture).texture;
      // envMap.isPmremTexture = true;
      pmremGenerator.dispose();
      tdm.scene!.environment = envMap; // 给场景添加环境光效果
      tdm.scene!.background = new THREE.Color(assistProps.background); // 给场景添加背景图
    })
  }

  // 控制面板
  const createPanel = ()=>{
    if(props.hidePanel){
      return
    }
    if(guiPanel){
      guiPanel.reset()
    }else{
      const panel = new GUI( { width: 250, container: guiRef.current!, title: '控制器' } );
      const { controls } = tdm
      panel.add(assistProps, "wireframe")
            .name("显示线框")
            .setValue(assistProps.wireframe)
            .onChange((v:boolean)=>{
              currentModel.group?.traverse((child:any)=> {
                if ( child.isMesh ) {
                  child.material.wireframe = v 
                }
              })
            })
      panel.add(assistProps, "grid")
            .name("辅助坐标")
            .setValue(assistProps.grid)
            .onChange((v:boolean)=>{
              setAssistProps({
                ...assistProps,
                grid: v
              })
            })
      panel.add(controls!, "autoRotate").name('自动旋转')
      panel.add(controls!, "autoRotateSpeed").name('旋转速度').setValue(controls?.autoRotateSpeed).min(0).max(10)
      panel.addColor(assistProps, "background")
              .name('背景颜色')
              .setValue(assistProps.background)
              .onChange((v:string)=>{
                tdm.scene!.background = new THREE.Color(v)
              })
      panel.add(assistProps, 'environment', environments.map((env:any) => env.name))
          .name('环境选择')
          .setValue(assistProps.environment)
          .onChange((v:string)=>{
            setAssistProps({
              ...assistProps,
              environment: v
            })
          })
      
      // panel.close()
      panel.hide()
      setGuiPanel(panel)
    }
  }

  // 更新相机位置
  const updateCamera = (object:THREE.Group)=>{

    const {controls, camera} = tdm

    object.updateMatrixWorld(); 
    
    const box = new THREE.Box3().setFromObject(object);
    const size = box.getSize(new THREE.Vector3()).length();
    const center = box.getCenter(new THREE.Vector3());

    controls?.reset()
    object.position.x += (object.position.x - center.x);
    object.position.y += (object.position.y - center.y);
    object.position.z += (object.position.z - center.z);
    controls!.maxDistance = size * 10;
    camera!.near = size / 100;
    camera!.far = size * 100;
    camera!.updateProjectionMatrix();

    camera!.position.copy(center);
    // camera!.position.x += size / 2.0;
    // camera!.position.y += size / 5.0;
    // camera!.position.z += size / 2.0;
    camera!.position.x += size / -2.0;
    camera!.position.y += 0;
    camera!.position.z += size / 1.5;
    camera!.lookAt(center);

    controls!.saveState();

    // 辅助坐标
    const axes = new THREE.AxesHelper(size/2)
    axes.renderOrder = 999;
    axes.onBeforeRender = (renderer) => renderer.clearDepth();
    const grid = new THREE.GridHelper(size)

    setAxesHelper(axes)
    setGridHelper(grid)

    setTdm({
      ...tdm,
      camera,
      controls,
    })
    return camera
  }

  const getSuffix = (url:string)=>{
    const i = url.lastIndexOf('.')
    if(i > -1){
      return url.substring(i+1)
    }
    return ''
  }
  // 动画播放完成事件
  const minerFinished = (e:any, num:number, cycle:string)=>{
    //console.log('finished', e)
    //console.log('playCycle clipNum', num)
    if(cycle === 'one'){
      const cb = playAnim(num)
      setPlayAnimCb(cb)
    }else if(cycle === 'all'){
      if(num >= animationActions!.length-1){
        setClipNum(0)
      }else{
        setClipNum(num+1)
      }
    }
  }

  useEffect(()=>{
    if(axesHelper && gridHelper){
      if(assistProps.grid){
        tdm.scene?.add(gridHelper)
        tdm.scene?.add(axesHelper)
      }else{
        tdm.scene?.remove(gridHelper)
        tdm.scene?.remove(axesHelper)
      }
    }
  }, [assistProps.grid])

  useEffect(()=>{
    setPercent(0)
    canvasInit()
    const trackBar = document.getElementById('trackBar')
    setBarwidth(trackBar!.offsetWidth!)
  },[])

  useEffect(()=>{
    if(document.fullscreenElement){
      setFullscreen(true)
    }else{
      setFullscreen(false)
    }
  }, [document.fullscreenElement])

  useEffect(()=>{
    if(pointRef.current){
      const tmp = pointRef.current.style.transform
      if(tmp && tmp !== 'translateX(0px)'){
        pointRef.current.style.transform = `translateX(${barWidth}px)`
      }
    }
  }, [barWidth])

  useEffect(()=>{
    const mixerListtener = (e:any)=>{
      return minerFinished(e, clipNum, playCycle)
    }
    const cb = playAnim()
    setPlayAnimCb(cb)

    if(tdm.mixer){
      tdm.mixer.addEventListener('finished', mixerListtener)
    }
    return ()=>{
      tdm.mixer?.removeEventListener('finished', mixerListtener)
    }
  }, [clipNum, playCycle])

  useEffect(()=>{
    //console.log('useEffect tdm.clips', tdm.clips)
    if(tdm.clips){
      setClipNum(0)
      setPlayCycle('one')
    }else{
      setClipNum(-1)
    }
  }, [tdm.clips])

  useEffect(()=>{
    if(tdm.renderer){
      const clock = new THREE.Clock();
      const timer = animation(clock)
      createPanel()

      return ()=>{
        cancelAnimationFrame(timer)
      }
    }
  }, [tdm.scene, tdm.mixer])

  useEffect(()=>{
    if(assistProps.environment && pmremGenerator){
      updateEnvironment()
    }
  }, [tdm.scene, assistProps.environment, pmremGenerator])


  const loadModeFile = async ()=>{
    setPercent(0)
    setLoadStatus('normal')
    setTip(TIP_LOADING)
    setAnimationActions([])

    // 加载HDR背景图
    if(props.hdr){
      hdrLoader(props.hdr)
    }
    let type = fileSxf || getSuffix(props.path!)
    let modelPath = props.path!
    if('zip, rar'.indexOf(type) !== -1 && compressDetailDTO){
      type = compressDetailDTO!.modelType!
      modelPath = compressDetailDTO!.modelPath!
    }
    // 加载模型
    let loader:GLTFLoader|FBXLoader|STLLoader, mtype = type || 'glb';
    if('glb, gltf'.indexOf(mtype) !== -1){
      // 转换模型为2.0 旧模型材质加载不出来
      let p = 0, pTimer
      try {
        // 模拟进度条
        pTimer = setInterval(()=>{
          setPercent(p++)
          if(p>70){
            clearInterval(pTimer!)
          }
        }, 100)

        // 转换成2.0
        const WEB_IO = new WebIO({credentials: 'include'})
            .registerExtensions(ALL_EXTENSIONS)
            // .registerDependencies({
            //   'draco3d.decoder': await draco3d.createDecoderModule(), // Optional.
            //   'draco3d.encoder': await draco3d.createEncoderModule(), // Optional.
            // })
        const document = await WEB_IO.read(modelPath)
        await document.transform(metalRough());
        const glb = await WEB_IO.writeBinary(document); // → Uint8Array
        const bb = new Blob([glb]);
        modelPath = URL.createObjectURL(bb)
      }catch(e){
        console.log(e)
      }finally{
        console.log('pTimer', pTimer)
        clearInterval(pTimer!)
      }
      
      const gltfLoader = new GLTFLoader()
          .setDRACOLoader( DRACO_LOADER )
          .setKTX2Loader( KTX2_LOADER.detectSupport( tdm.renderer! ) )
      loader = gltfLoader
    }else if('fbx'.indexOf(mtype) !== -1){
      loader = new FBXLoader()
    }else if('stl'.indexOf(mtype) !== -1){
      loader = new STLLoader()
    }else{
      setLoadStatus('exception')
      setTip(TIP_MODEL)
      return
    }

    //移除模型
    if(tdm.group){
      console.log('tdm.group', tdm.group)
      tdm.scene?.remove(tdm.group)
      tdm.group.traverse((obj:any)=>{
        if (obj.type === 'Mesh') {
          obj.geometry.dispose()
          obj.material.dispose()
        }
      })
    }
    if(axesHelper){
      tdm.scene?.remove(axesHelper)
      axesHelper.dispose()
    }
    if(gridHelper){
      tdm.scene?.remove(gridHelper)
      gridHelper.dispose()
    }

    // tdm.scene?.removeFromParent()

    loader.load(modelPath, (geometry:THREE.Group|GLTF|THREE.BufferGeometry)=> {
      setTip(TIP_SUCCESS)
      console.log('geometry', geometry)
      
      //当前模型 
      let model:THREE.Group
      let clips:THREE.AnimationClip[] = []
      if('fbx'.indexOf(mtype) !==-1){
        model = (geometry as THREE.Group)
        clips = model.animations
      }else if('stl'.indexOf(mtype) !== -1){
        const bufferGeometry = (geometry as THREE.BufferGeometry)
        const mesh = new THREE.Mesh(bufferGeometry)
        model = new THREE.Group()
        model.add(mesh)
      }else{
        const gltf = (geometry as GLTF)
        model = gltf.scene
        clips = gltf.animations
      }
      
      //自定义初始化当前模型
      if(props.init){
        props.init(model, geometry)
      }

      //默认遍历模型字节点，获取相关参数设置 特殊模型前往init回调中设置
      let childsResult:any = {
        cameras: [],
        lights: []
      }
      model.traverse(function(child:any) {
          //console.log(child)
          if (child.isMesh) {
            // child.material.emissiveMap = child.material.map;
            //child.material.side = THREE.DoubleSide;
            child.material.shininess=1;
            child.castShadow = true
            child.receiveShadow = true
            child.material.transparent=true;//材质允许透明 如果有玻璃材质时开启
            child.material.opacity=1;//材质默认透明度  
          }
          // traverseScene(n, result);
          if (child instanceof THREE.Camera) {
            childsResult.cameras.push(child);
          }
          // Look for lights
          if (child instanceof THREE.Light) {
            childsResult.lights.push(child);
          }
        } 
      )
      
      let updCamera:THREE.PerspectiveCamera|undefined
      //设置相机位置
      if(props.position){
        tdm.camera?.position.set(props.position.x, props.position.y, props.position.z)
      }else{
        // 设置相机位置
        if (childsResult.cameras && childsResult.cameras.length){
          const camera = childsResult.cameras[0]
          tdm.camera?.position.copy(camera.position.clone().add(new THREE.Vector3(0,0,.01)))
        }else {
          updCamera = updateCamera(model)
        }
      }
      
      currentModel = {group: model}
      //加载完成后开始自动播放
      setTimeout(()=>{
        tdm.controls!.autoRotate = typeof props.autoRotate ==='boolean'? props.autoRotate : false;
      }, 500);

      //把模型放入场景中
      const sc = tdm.scene!.add(model);
      const mixer = new THREE.AnimationMixer(model)
      let arr:THREE.AnimationAction[] = []
      // 动画
      let tranClips:THREE.AnimationClip[] = []
      if(!showStatic && clips){
        console.log('clips', clips)
        clips.forEach(item=>{
          if(item.duration>0){
            arr.push(mixer.clipAction(item))
            tranClips.push(item)
          }
        })
      }
      setAnimationActions(arr)

      if(printscreen){
        // 模型截图
        setTimeout(()=>{
          tdm.renderer?.render(tdm.scene!, updCamera || tdm.camera!)
          const img64 = tdm.renderer?.domElement.toDataURL()
          printscreen(img64!)
        }, 1000)
      }

      setTdm({
        ...tdm,
        scene: sc,
        mixer: mixer,
        clips: tranClips,
        group: model
      })
      setPercent(100)
    },
    (event: ProgressEvent)=>{
      const p = parseInt(event.loaded*100/event.total + '')
      if(p>=100){
        setLoadStatus('success')
      }else{
        setPercent(p)
      }
    },
    (event: ErrorEvent)=>{
      console.log(event)
      setTip(TIP_ERR)
      setLoadStatus('exception')
    }
  );

  }

  useEffect(()=>{
    // setPercent(100)
    // return
    if(props.path && tdm?.renderer){
      loadModeFile()
    }

    return ()=>{
      if(tdm.group){
        console.log('model dispose')
        tdm.scene?.remove(tdm.group)
        tdm.group.traverse((obj:any)=>{
          if (obj.type === 'Mesh') {
            obj.geometry.dispose()
            obj.material.dispose()
          }
        })
        setTdm({
          ...tdm,
          group: undefined
        })
      }
    }
  }, [tdm.renderer, props.path])

  const switchCycle = (type:string)=>{
    setPlayCycle(type)
  }

  const switchClip = (num:number)=>{
    setClipNum(num)
  }
  
  const menuShowClick = (e:any)=>{
    e.stopPropagation() 
    setMenuShow(!menuShow)
  }
  const hideMenu = ()=>{
    setMenuShow(false)
  }

  const playStopClick = ()=>{
    if(clipNum === -1){
      setPlaying(false)
      return
    }
    const b = playing
    const action = animationActions![clipNum]
    const maxDuration = action.getClip().duration
    if(!b){
      pointRef.current!.style.transition = `transform ${(maxDuration-parseFloat(playTime))*1000-50}ms linear 0s`
      pointRef.current!.style.transform = `translateX(${barWidth}px)`
      action.paused = false
    }else{
      console.log('stop')
      pointRef.current!.style.transition = 'none 0s ease 0s'
      pointRef.current!.style.transform = `translateX(${barWidth*parseFloat(playTime)/maxDuration}px)`
      action.paused = true
    }
    setPlaying(!b)
  }

  const nextClick= ()=>{
    if(animationActions){
      if(clipNum >= animationActions!.length-1){
        setClipNum(-1)
      }else{
        setClipNum(clipNum + 1)
      }
    }
  }

  const openSetting = ()=>{
    setShowGuiPanel(true)
    guiPanel?.show(true)
  }

  const hideSetting = ()=>{
    setShowGuiPanel(false)
    guiPanel?.show(false)
  }

  return (
    <div className={`${styles.threed} ${props.className}`}>
      <div className={styles.webgl} onClick={hideMenu}>
        <div className={styles.canvas} ref={canvasRef} >
          <div className={styles.assist}>
            <div className={styles.gui} ref={guiRef}></div>
            <div className={styles.controls} style={{'display': animationActions && animationActions.length>=0 ? '' : 'none'}}>
              <div className={styles.timeline}>
                <div className={styles.track}>
                  <div className={styles.bar} id="trackBar"></div>
                  <div className={styles.point} ref={pointRef}></div>
                </div>
              </div>
              <div className={styles.do}>
                <div className={styles.left}>
                  <div className={styles.item} onClick={playStopClick}>
                    {
                      !playing && 
                      <i className={`${styles.icon} play`}/>
                    }
                    {
                      playing && 
                      <i className={`${styles.icon} stop`}/>
                    }
                  </div>
                  <div className={styles.item} onClick={nextClick}>
                    <i className={`${styles.icon} next`}/>
                  </div>
                  <div className={styles.item}>
                    <span className={styles.playTime}>{playTime}</span>
                  </div>
                  <div className={styles.item}>
                    <span className={styles.text} onClick={menuShowClick.bind(this)}>{clipNum === undefined || clipNum === -1 || !tdm.clips || tdm.clips.length===0 ? '静态模型' : tdm.clips![clipNum].name}</span>
                    <i className={`${styles.icon} expend`} onClick={menuShowClick.bind(this)}/>
                    <div className={styles.anmenu} style={{"display": menuShow ? 'inline' : 'none'}} onClick={(e)=>{e.stopPropagation()}}>
                      <div className={styles.options}>
                        <div className={styles.btns}>
                          <div className={`${styles.btn} ${playCycle==='one' ? styles.active : ''}`} onClick={switchCycle.bind(this, 'one')}>
                            <i className={`${styles.icon} cycle-one`}/>
                          </div>
                          <div className={`${styles.btn} ${playCycle==='all' ? styles.active : ''}`} onClick={switchCycle.bind(this, 'all')}>
                            <i className={`${styles.icon} cycle-all`}/>
                          </div>
                          <div className={`${styles.btn} ${playCycle==='no-repeat' ? styles.active : ''}`} onClick={switchCycle.bind(this, 'no-repeat')}>
                            <i className={`${styles.icon} cycle-no-repeat`}/>
                          </div>
                        </div>
                      </div>
                      <div className={styles.clips}>
                        <div className={styles.item} onClick={switchClip.bind(this, -1)}>
                          <div className={styles.label}>静态模型</div>
                          {
                            clipNum === -1 && 
                            <i className={styles.selected}/>
                          }
                        </div>
                        {
                          tdm.clips?.map((item, index)=>{
                            return (
                              <div key={index} className={styles.item} onClick={switchClip.bind(this, index)}>
                                <div className={styles.label}>{item.name ? item.name : '-'}</div>
                                {
                                  clipNum === index && 
                                  <i className={styles.selected}/>
                                }
                              </div>
                            )
                          })
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.right}>
                  {
                    !showGuiPanel && 
                    <div className={styles.item} title="打开控制器" onClick={openSetting}>
                      <i className={`${styles.icon} setting1`}/>
                    </div>
                  }
                  {
                    showGuiPanel &&
                    <div className={styles.item} title="关闭控制器" onClick={hideSetting}>
                      <i className={`${styles.icon} setting2`}/>
                    </div>
                  }
                  {/* {
                    fullscreen && 
                    <div className={styles.item} title="退出全屏" onClick={()=>{document.exitFullscreen()}}>
                      <i className={`${styles.icon} exit-fullscreen`}/>
                    </div>
                  } */}
                  {
                    // !fullscreen &&
                    <div className={styles.item} title="全屏" onClick={()=>{tdm.renderer?.domElement.requestFullscreen()}}>
                      <i className={`${styles.icon} fullscreen`}/>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {
        percent < 100 &&
        <div className={styles.mask}>
          <img className={styles.coverImg} src={props.coverImg ? props.coverImg : defaultBg}/>
          <div className={styles.loading}>
            <div className={styles.tip}>{tip}</div>
            <Progress percent={percent} status={loadStatus} showInfo={false} className={styles.progress} size="small" trailColor="#ccc" strokeColor={COLOR_PRIMARY}/>
          </div>
        </div>
      }
    </div>
  )
}

export default ThreeDView